import React from 'react';
import { Button } from 'swag-client-common/components/ui/button';
import classes from './notecard-mobile-message.scss';
export const NotecardMobileMessage = ({
  onBack
}) => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "Let\u2019s update your notecard!"), /*#__PURE__*/React.createElement("div", {
    className: classes.subTitle
  }, "Please use dekstop version to update your box notecard"), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    dataButton: "Back",
    type: "primary",
    onClick: onBack
  }, "Back")));
};